import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {
    getOrderedColumns as getOrderedColumnsFromTable,
    getShownColumns as getShownColumnsFromTable,
    getTasksSorting,
} from '../selectors'
import {getColumnsOrder, getSelectedColumns} from './selectors'
import {arrayToSet} from "../../../atUtils"
import {changeTasksSortingAction, setColumnsOrder as setTableColumnsOrder, setColumnsShown as setTableColumnsShown} from '../actions'
import {savePageSettings} from '../../common/actions'
import {TaskTableDefaultSorting} from '../../constants'
import {isSortByColumnUnavailable} from './utils'

export const setColumnsOrder = createAction(ActionTypes.ORDER_SET)

export const setSelected = createAction(ActionTypes.SELECTED_SET)

export const changeColumnSelection = (column, selected) => (dispatch, getState) => {
    const selectedColumns = {...getSelectedColumns(getState())}

    if (selected)
        selectedColumns[column] = selected
    else
        delete selectedColumns[column]

    dispatch(setSelected(selectedColumns))
}

export const changeColumnOrder = (id, newIndex) => (dispatch, getState) => {
    let order = getColumnsOrder(getState())
    order = order.filter(column => column !== id)
    order.splice(newIndex, 0, id)
    dispatch(setColumnsOrder(order))
}


export const beforeOpen = () => (dispatch, getState) => {
    const order = getOrderedColumnsFromTable(getState())
    const shown = getShownColumnsFromTable(getState())
    const shownSet = arrayToSet(shown)
    dispatch(setColumnsOrder(order))
    dispatch(setSelected(shownSet))
}


export const saveChanges = () => (dispatch, getState) => {
    const state = getState()
    dispatch(restoreAndSetTableColumnsOrder())
    const selectedMap = getSelectedColumns(state)
    dispatch(setTableColumnsShown(Object.keys(selectedMap)))
    dispatch(afterClose())

    if (isSortByColumnUnavailable(getTasksSorting(state), selectedMap)) {
        //change sorting, reload tasks and save settings
        dispatch(changeTasksSortingAction(TaskTableDefaultSorting))
    } else {
        //save settings only without reloading tasks
        dispatch(savePageSettings())
    }
}


export const afterClose = () => (dispatch) => {
    dispatch(setSelected({}))
    dispatch(setColumnsOrder([]))
}

export const restoreAndSetTableColumnsOrder = () => (dispatch, getState) => {
    const state = getState()
    const filteredOrder = getColumnsOrder(state)
    const tableColumns = [...getOrderedColumnsFromTable(state)]

    let selectorOrderIndex = 0
    for (let i = 0; i < tableColumns.length; i++) {
        tableColumns[i] = filteredOrder[selectorOrderIndex++]
    }

    dispatch(setTableColumnsOrder(tableColumns))
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/actions.js